/* bm_peakExplorer_infoControl.js - accessible map usage information */
(() => {
  'use strict';

  function bm_peakExplorer_attachInfoControl({ map, text }) {
    const infoText = String(text || '').trim();
    if (!map || typeof map.addControl !== 'function' || !infoText) return null;

    let button = null;
    let container = null;
    let popover = null;
    let isRemoved = false;

    const setOpen = (isOpen) => {
      const nextOpen = Boolean(isOpen);
      if (!button || !popover) return;
      button.setAttribute('aria-expanded', String(nextOpen));
      popover.hidden = !nextOpen;
    };

    const handleButtonClick = () => {
      setOpen(button?.getAttribute('aria-expanded') !== 'true');
    };

    const handleDocumentPointerDown = (event) => {
      if (!container?.contains(event.target)) setOpen(false);
    };

    const handleDocumentKeyDown = (event) => {
      if (event.key !== 'Escape' || button?.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      button.focus({ preventScroll: true });
    };

    const control = {
      onAdd() {
        container = document.createElement('div');
        container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group bm-map-info-control';

        const popoverId = `bm-map-info-${Math.random().toString(36).slice(2, 10)}`;
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'bm-map-info-button';
        button.setAttribute('aria-label', 'Hinweise zur Kartenauswahl');
        button.setAttribute('aria-controls', popoverId);
        button.setAttribute('aria-expanded', 'false');
        button.title = 'Hinweise zur Kartenauswahl';
        button.textContent = 'i';

        popover = document.createElement('div');
        popover.id = popoverId;
        popover.className = 'bm-map-info-popover';
        popover.setAttribute('role', 'note');
        popover.textContent = infoText;
        popover.hidden = true;

        button.addEventListener('click', handleButtonClick);
        document.addEventListener('pointerdown', handleDocumentPointerDown);
        document.addEventListener('keydown', handleDocumentKeyDown);
        container.append(button, popover);
        return container;
      },
      onRemove() {
        button?.removeEventListener('click', handleButtonClick);
        document.removeEventListener('pointerdown', handleDocumentPointerDown);
        document.removeEventListener('keydown', handleDocumentKeyDown);
        container?.remove();
        button = null;
        popover = null;
        container = null;
        isRemoved = true;
      }
    };

    map.addControl(control, 'top-right');
    if (!button) return null;

    return {
      destroy() {
        if (!isRemoved && typeof map.removeControl === 'function') {
          map.removeControl(control);
        }
      }
    };
  }

  window.BM = window.BM || {};
  window.BM.bm_peakExplorer_attachInfoControl = bm_peakExplorer_attachInfoControl;
})();
